/* 🤖 this file was generated by svg-to-ts */
export const mgcIconRightRegular: {
  name: 'right-regular';
  data: string;
} = {
  name: 'right-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.939 5.435a1.099 1.099 0 0 0-.504.504c-.1.22-.097.589.008.821.062.138.671.771 2.608 2.71L13.579 12l-2.528 2.53c-1.937 1.939-2.546 2.572-2.608 2.71-.105.232-.108.601-.008.821a1 1 0 0 0 1.347.48c.152-.076.878-.78 3.144-3.05 2.857-2.861 2.949-2.958 3.01-3.168.08-.272.08-.374 0-.646-.061-.21-.153-.307-3.01-3.168-2.266-2.27-2.992-2.974-3.144-3.05a1.066 1.066 0 0 0-.843-.024"/></svg>`
};
